import * as getMarkets from './reducers/get';
import * as query from './reducers/query';
import { subscribe, unsubscribe } from './reducers/subscription';
import * as update from './reducers/update';
import * as addSelection from './reducers/add-selection';
import * as settle from './reducers/settle';
import * as addRule4 from './reducers/add-rule4';
import * as updateRule4 from './reducers/update-rule4';
import * as addDividend from './reducers/add-dividend';
import * as updateDividend from './reducers/update-dividend';
import * as addAllSelections from './reducers/add-all-selections';
import * as moveMarkets from './reducers/move-markets';
import * as marketsByEventId from './reducers/get-all-markets-by-event';

import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    MARKETS_REQUEST: getMarkets.request,
    MARKETS_ERROR: getMarkets.error,
    MARKETS_FINISH: getMarkets.finish,

    MARKETS_QUERY_REQUEST: query.request,
    MARKETS_QUERY_ERROR: query.error,
    MARKETS_QUERY_FINISH: query.finish,

    MARKETS_ADD_RULE4_REQUEST: addRule4.request,
    MARKETS_ADD_RULE4_ERROR: addRule4.error,
    MARKETS_ADD_RULE4_FINISH: addRule4.finish,

    MARKETS_UPDATE_RULE4_REQUEST: updateRule4.request,
    MARKETS_UPDATE_RULE4_ERROR: updateRule4.error,
    MARKETS_UPDATE_RULE4_FINISH: updateRule4.finish,

    MARKETS_ADD_DIVIDEND_REQUEST: addDividend.request,
    MARKETS_ADD_DIVIDEND_ERROR: addDividend.error,
    MARKETS_ADD_DIVIDEND_FINISH: addDividend.finish,

    MARKETS_UPDATE_DIVIDEND_REQUEST: updateDividend.request,
    MARKETS_UPDATE_DIVIDEND_ERROR: updateDividend.error,
    MARKETS_UPDATE_DIVIDEND_FINISH: updateDividend.finish,

    MARKETS_ADD_SELECTION_REQUEST: addSelection.request,
    MARKETS_ADD_SELECTION_ERROR: addSelection.error,
    MARKETS_ADD_SELECTION_FINISH: addSelection.finish,

    MARKETS_SETTLE_REQUEST: settle.request,
    MARKETS_SETTLE_ERROR: settle.error,
    MARKETS_SETTLE_FINISH: settle.finish,

    MARKETS_UPDATE_REQUEST: update.request,
    MARKETS_UPDATE_ERROR: update.error,
    MARKETS_UPDATE_FINISH: update.finish,

    MARKETS_ADD_ALL_SELECTIONS_REQUEST: addAllSelections.request,
    MARKETS_ADD_ALL_SELECTIONS_ERROR: addAllSelections.error,
    MARKETS_ADD_ALL_SELECTIONS_FINISH: addAllSelections.finish,

    MARKETS_SUBSCRIBE: subscribe,
    MARKETS_UNSUBSCRIBE: unsubscribe,

    MARKETS_DATA: update.bulk,
    MARKET_DATA: update.update,

    EVENTS_MOVE_MARKET_REQUEST: moveMarkets.request,
    EVENTS_MOVE_MARKET_ERROR: moveMarkets.error,
    EVENTS_MOVE_MARKET_FINISH: moveMarkets.finish,

    GET_MARKETS_BY_EVENTID_REQUEST: marketsByEventId.request,
    GET_MARKETS_BY_EVENTID_ERROR: marketsByEventId.error,
    GET_MARKETS_BY_EVENTID_FINISH: marketsByEventId.finish,
});
